import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL; 
// should be "https://apidev.frayo.net/v1/order-tracking"

export const getDriverMapPoints = async (orderId: string) => {
  try {
    const response = await axios.get(`${API_URL}/driver-tracking`, {
      params: { orderId }, 
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching driver map points:", error.response?.data || error.message);
    throw error;
  }
};
export const getOrderTrackingDetails = async (orderId: string) => {
  try {
    const response = await axios.get(`${API_URL}/order-tracking-details`, {
      params: { orderId },
    });

    return response.data;
  } catch (error: any) {
    console.error(
      "Error fetching order tracking details:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const getUserDriverMapPoints = async (orderId: string) => {
  try {
    const response = await axios.get(`${API_URL}/user-driver-tracking`, {
      params: { orderId },
    });
    return response.data;
  } catch (error: any) {
    console.error("Error fetching user driver map points:", error.response?.data || error.message);
    throw error;
  }
};
